import styled from 'styled-components';
import PressContainer from '../../atoms/PressContainer/PressContainer';

export const Container = styled(PressContainer)`
  margin: 0 auto;
  max-width: 825px;
`;

export const StyledUpdateDate = styled.div`
  text-align: center;
  padding-bottom: 20px;
`;
